import { DeleteOutlined, FileImageOutlined } from "@ant-design/icons";
import {
  Layout,
  AutoComplete,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Collapse,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tooltip,
  Upload,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useNavigate } from "react-router-dom";
import PhoneOtpVerify from "../../authentication/PhoneOtpVerify";
import VerifyOtpModal from "../../authentication/VerifyOtpModel";
import pfdLogo from "../../image/pdf.png";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import EmailField from "../../common/htmlComponents/EmailField";
import InputField from "../../common/htmlComponents/InputField";
import TextAreaField from "../../common/htmlComponents/TextAreaField";
import { ReactComponent as About } from "../../image/About.svg";
import { ReactComponent as AddressLine } from "../../image/AddressLine.svg";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { ReactComponent as Email } from "../../image/Email.svg";
import { ReactComponent as FileAlt } from "../../image/FileAlt.svg";
import { ReactComponent as IdcardOutlined } from "../../image/IdcardOutlined.svg";
import { ReactComponent as Name } from "../../image/Name.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import { ReactComponent as User } from "../../image/User.svg";
import { ReactComponent as Vector } from "../../image/Vector.svg";
import verifybtn from "../../image/verifybtn.png";
import { ReactComponent as Website } from "../../image/Website.svg";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import CompanyOnboardingLogo from "../companyOnboarding/CompanyOnboardingLogo";
import KeyPersonCompany from "./KeyPersonCompany";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const { Search } = Input;
const { Content } = Layout;
const MyCompany = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [verifyPhoneButtonView, setVerifyPhoneButtonView] = useState(true);
  const [btnLoadingVerifyGst, setBtnLoadingVerifyGst] = useState(false);
  const [verifyAdhaarButtonView, setVerifyAdhaarButtonView] = useState(true);
  const [verifyPancardButtonView, setVerifyPancardButtonView] = useState(true);
  const [minutesPhone, setMinutesPhone] = useState(1);
  const [secondsPhone, setSecondsPhone] = useState(0);
  const [OTPPhone, setOTPPhone] = useState(null);
  const [isModalOpenPhone, setIsModalOpenPhone] = useState(false);
  const [CId, setCId] = useState(null);
  const [verificationResultAdhaar, setVerificationResultAadhaar] =
    useState(null);
  const [verificationResultPancard, setVerificationResultPancard] =
    useState(null);
  const [pincodeListShipping, setPincodeListShipping] = useState([]);
  const formRef = useRef();
  const [sameAsCurrentAddress, setSameAsCurrentAddress] = useState(false);
  const initialDocument = { company: null, attachment_name: null };
  const [verifyEmailButtonView, setVerifyEmailButtonView] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);
  const [OTP, setOTP] = useState(null);

  const initialState = {
    name: null,
    first_name: null,
    designation: null,
    email: null,
    phone: null,
    address_line_1: null,
    address_line_2: null,
    city: null,
    state: null,
    pincode: null,
    website: null,
    no_of_employees: null,
    email_verified: false,
    phone_verified: false,
    pan_verified: false,
    udyam_aadhaar_no_verified: false,
    gst_no_verified: false,
    company_pan: null,
    gst_no: null,
    about_company: null,
    sector: null,
    cin_no: null,
    keypersons: [
      {
        person_name: null,
        email: null,
        designation: null,
        contact_number: null,
      },
    ],
  };
  const [state, setState] = useState(initialState);
  const [btnLoadingEmail, setBtnLoadingEmail] = useState(false);
  const [btnLoadingPan, setBtnLoadingPan] = useState(false);
  const [verificationResultEmail, setVerificationResultEmail] = useState(null);
  const [btnLoadingAdhaar, setBtnLoadingAdhaar] = useState(false);
  const { Panel } = Collapse;
  const [errorMsg, setErrorMsg] = useState("");
  const [verificationResultGST, setVerificationResultGST] = useState(null);
  const [btnLoadingFile, setBtnLoadingFile] = useState(false);
  const [apiloadingFile, setapiloadingFile] = useState(false);
  const [documentState, setDocumentState] = useState(initialDocument);
  const [fileLinkadhar, setFileLinkadhar] = useState(null);
  const [fileLinkPan, setFileLinkPan] = useState(null);
  const [fileLinkGst, setFileLinkGst] = useState(null);
  const [btnDisplay, setBtnDisplay] = useState("Add");
  const [uploadFileAadhar, setUploadFileAadhar] = useState("");
  const [uploadFilePan, setUploadFilePan] = useState("");
  const [uploadFileGst, setUploadFileGst] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [addedCompanyId, setAddedCompanyId] = useState(null);
  const [apiloading, setapiloading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [size, setSize] = useState(null);
  const [uploadFile, setUploadFile] = useState("");
  const [fileLink, setFileLink] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [companyDocumentId, setCompanyDocumentId] = useState(null);
  const { Option } = AutoComplete;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [companyDocumentList, setCompanyDocumentList] = useState([]);
  const [sectorName, setSectorName] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [btnLoadingPhone, setBtnLoadingPhone] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploadFileProfilePic, setUploadFileProfilePic] = useState("");
  const [pincodeListBilling, setPincodeListBilling] = useState([]);
  const [verificationResultContact, setVerificationResultContact] =
    useState(null);
  const [verifyGstButtonView, setVerifyGstButtonView] = useState(true);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [identifyProfileUrl, setIdentifyProfileUrl] = useState(null);
  const [stateTable, setStateTable] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  let filename = "";

  const onSearchBilling = async (value) => {
    value.length >= 4
      ? searchINBilling(!value ? null : value)
      : setPincodeListBilling([]);
  };

  const handleGstInputChange = async (e) => {
    let { name, value } = e.target;
    setVerifyGstButtonView(true);

    setState({ ...state, gst_no: value, gst_no_verified: false });
    setVerificationStatus(null);
  };

  const handleInputAdhaarChange = (e) => {
    let { name, value } = e.target;
    setVerificationResultAadhaar("");
    setVerifyAdhaarButtonView(true);
    setState({
      ...state,
      udyam_aadhaar_no: value !== "" ? value : null,
      udyam_aadhaar_no_verified: false,
    });
  };

  const handleInputPancardChange = (e) => {
    let { name, value } = e.target;
    setVerificationResultPancard("");
    setVerifyPancardButtonView(true);
    setState({
      ...state,
      company_pan: value !== "" ? value : null,
      pan_verified: false,
    });
  };

  const handleSendOtpEmail = async () => {
    try {
      const payload = {
        email: state?.email ? state.email : "",
      };
      const response = await postRequest(`verified-otp/email-verify/`, payload);

      if (response.data.success) {
        const errorMessage = response?.data?.message || "";
        const emailVerificationRegex = /This [^ ]+ already Verify/;

        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyEmailButtonView(false);
          setState((prevState) => ({
            ...prevState,
            email_verified: true,
          }));
          setVerificationResultEmail("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            email_verified: false,
          }));
          showModal();
          setVerifyEmailButtonView(true);
        }
        SuccessNotificationMsg(response.data.message);
      } else {
        handleCancel();
        setVerificationResultEmail("");
      }
    } catch (error) {
      handleCancel();
      setVerifyEmailButtonView(true);
      setVerificationResultEmail("");
    }
  };

  const handleSendOtpPhone = async () => {
    try {
      const payload = {
        phone_number: state?.phone ? state.phone : "",
      };
      const response = await postRequest(
        `verified-otp/phone-number-verify/`,
        payload
      );

      if (response.data.success) {
        const errorMessage = response?.data?.message || "";
        const emailVerificationRegex = /This [^ ]+ already Verify/;

        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyPhoneButtonView(false);
          setState((prevState) => ({
            ...prevState,
            phone_verified: true,
          }));
          setVerificationResultContact("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            phone_verified: false,
          }));
          showModalPhone();
          setVerifyPhoneButtonView(true);
        }
        SuccessNotificationMsg(response.data.message);
      } else {
        setVerificationResultContact("");
        handleCancelPhone();
        setVerifyPhoneButtonView(true);
      }
    } catch (error) {
      setVerifyPhoneButtonView(true);
      handleCancelPhone();
      setVerificationResultContact("");
    }
  };

  const showModalPhone = () => {
    setIsModalOpenPhone(true);
  };

  const handleOkPhone = () => {
    setIsModalOpenPhone(false);
  };

  const handleCancelPhone = () => {
    setIsModalOpenPhone(false);
    setOTPPhone(null);
    setSecondsPhone(30);
    setMinutesPhone(1);
    setBtnLoadingPhone(false);
  };

  const handleSameAsCurrentAddressChange = (e) => {
    const checked = e.target.checked;
    setSameAsCurrentAddress(checked);

    if (checked) {
      setState((prevState) => ({
        ...prevState,
        same_as_billing_address: true,
        trading_address_state: prevState.registered_business_address_state,
        trading_address_city: prevState.registered_business_address_city,
        trading_address_building:
          prevState.registered_business_address_building,
        trading_address_area: prevState.registered_business_address_area,
        trading_address_landmark:
          prevState.registered_business_address_landmark,
        trading_address_pincode: prevState.registered_business_address_pincode,
        trading_address_pincode_number:
          prevState.registered_business_address_pincode_number,
      }));

      formRef.current.setFieldsValue({
        trading_address_state: state.registered_business_address_state,
        trading_address_city: state.registered_business_address_city,
        trading_address_building: state.registered_business_address_building,
        trading_address_area: state.registered_business_address_area,
        trading_address_landmark: state.registered_business_address_landmark,
        trading_address_pincode:
          state.registered_business_address_pincode_number,
      });
    } else {
      setState((prevState) => ({
        ...prevState,
        same_as_billing_address: false,
        trading_address_state: "",
        trading_address_city: "",
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_pincode_number: "",
      }));

      formRef.current.setFieldsValue({
        trading_address_state: "",
        trading_address_city: "",
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_pincode_number: "",
        trading_address_pincode: null,
      });
    }
  };

  const onSearchShipping = async (value) => {
    value.length >= 4
      ? searchINShipping(!value ? null : value)
      : setPincodeListShipping([]);
  };

  const searchINShipping = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListShipping(apiResponse.data.results.data);
    }
  };

  const truncateFileName = (fileName, maxLength = 27) => {
    if (!fileName) return "";
    if (fileName.length <= maxLength) return fileName;
    const extIndex = fileName.lastIndexOf(".");
    const extension = extIndex !== -1 ? fileName.slice(extIndex) : "";
    const truncated = fileName.slice(0, maxLength - extension.length);
    return `${truncated}...${extension}`;
  };
  const handlePincodeShippingChange = async (trading_address_pincode) => {
    if (trading_address_pincode && trading_address_pincode.length > 4) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${trading_address_pincode}`
        );
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id, pincode_number } =
            response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            trading_address_state: state_name,
            trading_address_city: city_name,
            trading_address_pincode: id,
            trading_address_pincode_number: pincode_number,
          }));
          formRef.current.setFieldsValue({
            trading_address_state: state_name,
            trading_address_city: city_name,
          });
        }
      } catch (error) {
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        trading_address_state: "",
        trading_address_city: "",
        trading_address_pincode: null,
        trading_address_pincode_number: "",
      }));
      formRef.current.setFieldsValue({
        trading_address_state: "",
        trading_address_city: "",
      });
    }
  };

  const handlePincodeBillingChange = async (
    registered_business_address_pincode
  ) => {
    if (
      registered_business_address_pincode &&
      registered_business_address_pincode.length > 4
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${registered_business_address_pincode}`
        );
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id, pincode_number } =
            response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
            registered_business_address_pincode: id,
            registered_business_address_pincode_number: pincode_number,
          }));
          formRef.current.setFieldsValue({
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
          });
        }
      } catch (error) {
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        registered_business_address_state: "",
        registered_business_address_city: "",
        registered_business_address_pincode: null,
        registered_business_address_pincode_number: "",
      }));
      formRef.current.setFieldsValue({
        registered_business_address_state: "",
        registered_business_address_city: "",
      });
    }
  };

  const searchINBilling = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListBilling(apiResponse.data.results.data);
    }
  };

  const handleChange = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const handlePhoneInputChange = (phone) => {
    setVerifyPhoneButtonView(true);
    setState((prevState) => ({
      ...prevState,
      phone: phone,
      phone_verified: false,
    }));
    setVerificationResultContact("");
  };

  const handleAdhaarNumberVerify = async () => {
    try {
      const adhaarNumber = state?.udhyam_aadharcard;

      if (adhaarNumber) {
        setBtnLoadingAdhaar(true);
        const response = await getRequest(
          `/doc-verification/udhyam/?udhyam_no=${adhaarNumber}`
        );
        if (response.data.results.data) {
          SuccessNotificationMsg("Udyam Number verified successfully");
          setVerificationResultAadhaar("success");
          setBtnLoadingAdhaar(false);
        } else {
          ErrorNotificationMsg(t("Invalid number"));
          setBtnLoadingAdhaar(false);
          setVerificationResultAadhaar("error");
        }
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying number"));
      setBtnLoadingAdhaar(false);
      setVerificationResultAadhaar("error");
    }
  };

  const handlePancardNumberVerify = async () => {
    try {
      const pancard = state?.company_pan;
      const gstRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (!pancard || !gstRegex.test(pancard)) {
        ErrorNotificationMsg(t("Invalid pancard number"));
        setVerificationResultPancard("error");
        return;
      }

      setBtnLoadingPan(true);
      const response = await getRequest(
        `doc-verification/pan/?pan_no=${pancard}`
      );
      if (response?.data?.data?.status === "id_found") {
        SuccessNotificationMsg("Pancard verified successfully");
        setVerificationResultPancard("success");
        setBtnLoadingPan(false);
      } else {
        ErrorNotificationMsg(t("Invalid pancard number"));
        setBtnLoadingPan(false);
        setVerificationResultPancard("error");
      }
    } catch (error) {
      ErrorNotificationMsg(t("Invalid Pan Number"));
      setVerificationResultPancard("error");
      setBtnLoadingPan(false);
    }
  };

 
  useEffect(() => {
    const getCompanyOnboarding = async () => {
      setapiloading(true); 
      try {
        const apiResponse = await getRequest("company/" + CompanyId);
        if (apiResponse.data.success) {
          setState({
            ...apiResponse.data.data,
            name: apiResponse.data.data.name,
            pincode: apiResponse.data.data.pincode,
            udyam_aadhaar_no: apiResponse.data.data.udhyam_aadharcard,
            keypersons: apiResponse.data.data.keypersons.map((e) => ({
              person_name: e.person_name,
              email: e.email,
              designation: e.designation,
              department: e.department,
              contact_number: e.contact_number,
            })),
          });
          setFileLinkadhar(apiResponse.data?.data?.upload_aadharcard);
          setFileLinkPan(apiResponse.data?.data?.upload_pancard);
          setFileLinkGst(apiResponse.data?.data?.upload_gst);
          const url = apiResponse.data.data.company_logo;
          setIdentifyProfileUrl(apiResponse.data.data.company_logo);
          setCId(apiResponse.data.data.id);
          if (url !== null) {
            setFileList([
              {
                url: url,
              },
            ]);
          }

          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            pincode: apiResponse.data.data.pincode_number,
            phone: String(apiResponse.data.data.phone),
            city: apiResponse.data.data.city_name,
            trading_address_pincode:
              apiResponse.data.data.trading_address_pincode_number,
            udyam_aadhaar_no: apiResponse.data.data.udhyam_aadharcard,
            registered_business_address_pincode:
              apiResponse.data.data.registered_business_address_pincode_number,
          });
          setWeightSizeFieldValue(apiResponse.data.data.keypersons);
          const response = apiResponse.data.data;
          if (
            response?.registered_business_address_state ===
              response?.trading_address_state &&
            response?.registered_business_address_city ===
              response?.trading_address_city &&
            response?.registered_business_address_building ===
              response?.trading_address_building &&
            response?.registered_business_address_area ===
              response?.trading_address_area &&
            response?.registered_business_address_landmark ===
              response?.trading_address_landmark &&
            response?.registered_business_address_pincode ===
              response?.trading_address_pincode
          ) {
            setSameAsCurrentAddress(true);
          }
        } else {
          ErrorNotificationMsg(t("err_getCompanydetail")); 
          sameAsCurrentAddress(false);
        }
        if (apiResponse?.data?.data?.email_verified === true) {
          setVerificationResultEmail("success");
          setVerifyEmailButtonView(false);
        } else {
          setVerificationResultEmail(null);
          setVerifyEmailButtonView(true);
        }

        if (apiResponse?.data?.data?.phone_verified === true) {
          setVerificationResultContact("success");
          setVerifyPhoneButtonView(false);
        } else {
          setVerificationResultContact(null);
          setVerifyPhoneButtonView(true);
        }

        if (apiResponse?.data?.data?.company_pan_verified === true) {
          setVerificationResultPancard("success");
          setVerifyPancardButtonView(false);
        } else {
          setVerificationResultPancard(null);
          setVerifyPancardButtonView(true);
        }

        if (apiResponse?.data?.data?.udyam_aadhaar_no_verified === true) {
          setVerificationResultAadhaar("success");
          setVerifyAdhaarButtonView(false);
        } else {
          setVerificationResultAadhaar(null);
          setVerifyAdhaarButtonView(true);
        }

        if (apiResponse?.data?.data?.gst_no_verified === true) {
          setVerificationStatus("success");
          setVerifyGstButtonView(false);
        } else {
          setVerificationStatus(null);
          setVerifyGstButtonView(true);
        }

        setFormSubmitted(true); 
        setAddedCompanyId(CompanyId); 
        setapiloading(false);
      } catch (error) {
        setapiloading(false); 
      }
    };

    if (CompanyId !== null) {
      getCompanyOnboarding();
    }
  }, [CompanyId, t]);
  const uploadProps = {
    accept: ".jpg, .png,.pdf,.jpeg",
    showUploadList: false,
    beforeUpload: (file, index) => {
      setSize(file.size);
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
      if (!allowedTypes.includes(file.type)) {
        message.error("Invalid file type. Only JPG, PNG And PDF are allowed.");
        return Upload.LIST_IGNORE;
      }
      if (file.size <= 2097152) {
        setSize(file.size);
        setUploadFile(file);
        setFileName(file.name);
        setFileLink(null);
      } else {
        alert("File size exceeds 2MB.");
        return Promise.reject();
      }
    },
  };

  const handleContactNumberVerify = async () => {
    const contactNumber = state?.phone;
    const phoneNumberPattern = /^\d{12}$/; 

    if (contactNumber && phoneNumberPattern.test(contactNumber)) {
      await handleSendOtpPhone(); 
    } else {
      ErrorNotificationMsg("Enter valid mobile number"); 
    }
  };

  const handleGstNumberVerify = async () => {
    try {
      const gst = state?.gst_no;
      const gstRegex =
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (!gst || !gstRegex.test(gst)) {
        ErrorNotificationMsg(t("Invalid GST No."));
        setVerificationResultGST("error"); 
        return;
      }

      setBtnLoading(true); 
      const response = await getRequest(`doc-verification/gst/?gst_no=${gst}`);
      if (response.data.results.data) {
        SuccessNotificationMsg("GST verified successfully"); 
        setVerificationResultGST("success"); 
      } else {
        ErrorNotificationMsg(t("Invalid GST No.")); 
        setVerificationResultGST("error"); 
      }
      setBtnLoading(false); 
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying GST number")); 
      setVerificationResultGST("error"); 
      setBtnLoading(false); 
    }
  };

  useEffect(() => {
    const getCompanyDocument = async () => {
      setapiloading(true);

      try {
        let filename1;
        const apiResponse = await getRequest(
          "company-attachment/" + companyDocumentId
        );

        if (apiResponse.data.success) {
          setDocumentState({
            ...apiResponse.data.data,
          });
          try {
            filename1 = apiResponse.data.data.attachment_file.split("/").pop();
            setFileName(filename1);
          } catch (e) {
            filename1 = "";
            setFileName(null);
          }
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
          });
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
          setapiloading(false);
        }
        setapiloading(false); 
      } catch (error) {
        setapiloading(false); 
      }
    };
    if (companyDocumentId !== null) {
      getCompanyDocument(); 
    }
  }, [companyDocumentId, t]);

  useEffect(() => {
    const getCompanyDocumentList = async () => {
      setLoading(true);
      try {
        let apiResponse = await getRequest(
          `company-id-attachment/${addedCompanyId}/`,
          stateTable
        );

        if (apiResponse.data.success === true) {
          setCompanyDocumentList(apiResponse.data.data);
          settotalCount(apiResponse.data.count); 
        }
        setLoading(false); 
      } catch (error) {
        setLoading(false); 
      }
    };
    if (addedCompanyId !== null) {
      getCompanyDocumentList(); 
    }
  }, [stateTable, reload, t, refreshGrid, addedCompanyId]);

  useEffect(() => {
    const getSectorName = async (data) => {
      await getRequest("sectorname/?no_pagination=True", data).then(
        (response) => {
          setSectorName(response.data.data); 
        }
      );
    };
    getSectorName();
  }, []);

  const urlpan = state?.upload_pancard;
  let filenamepan = "";
  try {
    if (fileLinkPan) {
      filenamepan = urlpan.split("/").pop();
    }
  } catch (e) {
    filenamepan = "";
  }
  const urlgst = state?.upload_gst;
  let filenamegst = "";
  try {
    if (fileLinkGst) {
      filenamegst = urlgst.split("/").pop(); 
    }
  } catch (e) {
    filenamegst = "";
  }
  const urladhaar = state?.upload_aadharcard;
  let filenameaadhar = "";
  try {
    if (fileLinkadhar) {
      filenameaadhar = urladhaar.split("/").pop(); 
    }
  } catch (e) {
    filenameaadhar = "";
  }

  const handleSectorSelectChange = async (value) => {
    setState({ ...state, sector: value }); 
  };

  const handleEditIconClick = (id) => {
    setCompanyDocumentId(id);
    setBtnDisplay("Edit"); 
  };

  const handleRefreshGrid = () => {
    setRefreshGrid((refreshGrid) => !refreshGrid); 
  };

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject[`person_name${objectKey}`] = objectValue.person_name;
      fieldObject[`email${objectKey}`] = objectValue.email;
      fieldObject[`designation${objectKey}`] = objectValue.designation;
      fieldObject[`contact_number${objectKey}`] = String(
        objectValue.contact_number || "+91"
      );
      return null;
    });

    formRef.current.setFieldsValue(fieldObject); 
  };

  const phoneValidLength = state.phone && state.phone;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error(t("please_enter_valid_phone"))); 
    }

    return Promise.resolve(); 
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value ? value : null }); 
  };

  const handleInputChangeEmail = (e) => {
    let { name, value } = e.target;
    setVerifyEmailButtonView(true); 
    setVerificationResultEmail(""); 
    setState((prevState) => ({
      ...prevState,
      email: value !== "" ? value : null,
      email_verified: false,
    }));
  };

  const handleEmailVerify = async () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
    const isEmailValid = emailPattern.test(state.email);
    if (isEmailValid) {
      await handleSendOtpEmail(); 
    } else {
      setVerifyEmailButtonView(true); 
      ErrorNotificationMsg("Enter valid email");
    }
  };

  const handleDocumentChange = (e) => {
    let { name, value } = e.target;
    setDocumentState({ ...documentState, [name]: value !== "" ? value : null }); 
  };

  const showModal = () => {
    setIsModalOpen(true); 
  };

  const handleOk = () => {
    setIsModalOpen(false); 
  };

  const handleCancel = () => {
    setIsModalOpen(false); 
    setOTP(null);
    setSeconds(30); 
    setMinutes(1);
    setBtnLoadingEmail(false); 
  };

  const handleSelectChange = (name, value) => {
    setState({ ...state, [name]: value });
  };
  const handleDelete = () => {
    setState((prevState) => ({
      ...prevState,
      attachment_file: null, 
    }));
    setUploadFile(""); 
    setFileName(null); 
    setSize(null); 
  };

  const handleFileDelete = async () => {
    try {
      const apiResponse = await deleteRequest(
        `company-image-delete/${CompanyId}/`
      );
      if (apiResponse.data.success) {
        setFileLink(null);
        setFileName(null);
        setSize(null);
      }
    } catch (error) {
      console.error("Error deleting file:", error);
    }
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setStateTable({
      ...stateTable,
      page: pagination.current, 
      pagesize: pagination.pageSize, 
      ordering: orderBy, 
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id"; 
    if (sortField === "attachment_name" && sortOrder === "ascend") {
      sortingEnumKey = "attachment_name";
    }
    if (sortField === "attachment_name" && sortOrder === "descend") {
      sortingEnumKey = "-attachment_name";
    }
    if (sortField === "attachment_file" && sortOrder === "ascend") {
      sortingEnumKey = "attachment_file";
    }
    if (sortField === "attachment_file" && sortOrder === "descend") {
      sortingEnumKey = "-attachment_file";
    }
    return sortingEnumKey; 
  };


  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearchTable);
  };


  const onSearchTable = (value) => {
    setStateTable({
      ...stateTable,
      search: value,
    });
  };


  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const debounceLoadData = debounce((value, onSearchTable) => {
    onSearchTable(value); 
  }, 1000); 

  
  const handleArchive = async (id = "") => {
    let ids = selectedRow; 
    if (ids.length === 0) {
      ids.push(id); 
    }
    try {
      let apiResponse = await postRequest("company-attachment-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("document_archive_successfully")); 
        setReload(!reload); 
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_document_archive")); 
      }
    } catch (error) {
      ErrorNotificationMsg(t("error_in_document_archive")); 
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      setErrorMsg("You can only upload JPG/PNG file!"); 
      message.error("You can only upload JPG/PNG file!");
      return Upload.LIST_IGNORE;
    }
    setErrorMsg(""); 
    return false; 
  };
  const columns = [
    {
      title: "Title",
      dataIndex: "attachment_name",
      key: "attachment_name",
      sorter: true,
    },
    {
      title: "Document",
      dataIndex: "attachment_file",
      key: "attachment_file",
      sorter: true,
      render: (attachment_file) =>
        attachment_file && (
          <>
            <a
              style={{ textDecoration: "none", color: "black" }}
              href={`${attachment_file}`}
              download
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={
                  attachment_file.endsWith(".pdf") ? pfdLogo : attachment_file
                }
                style={{ width: "40px", height: "40px", objectFit: "cover" }}
                alt={
                  attachment_file.endsWith(".pdf")
                    ? "PDF Logo"
                    : "Document Preview"
                }
              />
            </a>
          </>
        ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      render: (text, record) => (
        <Space>
          <Editicon onClick={() => handleEditIconClick(record.id)} />

          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleArchive(record.id)}
          >
            <Archive style={{ cursor: "pointer" }} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      const payload = {
        name: state.name,
        first_name: state.first_name,
        designation: state.designation,
        email: state.email,
        phone: state.phone,
        email_verified: state.email_verified,
        phone_verified: state.phone_verified,
        pan_verified: state.pan_verified,
        udyam_aadhaar_no_verified: state.udyam_aadhaar_no_verified,
        gst_no_verified: state.gst_no_verified,
        website: state.website,
        no_of_employees: state.no_of_employees,
        company_pan: state.company_pan,
        gst_no: state.gst_no,
        about_company: state.about_company,
        sector: state.sector,
        cin_no: state.cin_no,
        udhyam_aadharcard: state.udhyam_aadharcard,
        registered_business_address_building:
          state.registered_business_address_building,
        registered_business_address_area:
          state.registered_business_address_area,
        registered_business_address_landmark:
          state.registered_business_address_landmark,
        registered_business_address_state:
          state.registered_business_address_state,
        registered_business_address_city:
          state.registered_business_address_city,
        registered_business_address_pincode:
          state.registered_business_address_pincode,

        trading_address_building: state.trading_address_building,
        trading_address_area: state.trading_address_area,
        trading_address_landmark: state.trading_address_landmark,
        trading_address_state: state.trading_address_state,
        trading_address_city: state.trading_address_city,
        trading_address_pincode: state.trading_address_pincode,

        keypersons:
          state.keypersons &&
          state.keypersons.every(
            (person) =>
              person.person_name === null &&
              person.email === null &&
              person.designation === null &&
              person.department === null &&
              person.contact_number === null
          )
            ? []
            : state.keypersons,
      };
      const formData = new FormData();
      formData.append("company_logo", uploadFileProfilePic);
      formData.append("upload_aadharcard", uploadFileAadhar);
      formData.append("upload_pancard", uploadFilePan);
      formData.append("upload_gst", uploadFileGst);
      formData.append("form_data", JSON.stringify(payload));
      let response;
      if (CompanyId === null) {
        response = await postRequest("company/", formData);
      } else {
        response = await patchRequest(`company/${CompanyId}/`, formData);
      }

      if (response.data.success) {
        setAddedCompanyId(response.data.data.id);
        SuccessNotificationMsg(
          CompanyId === null
            ? t("company_added_successfully")
            : t("company_updated_successfully")
        );
        setFormSubmitted(true);
        setBtnLoading(false);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const handleCompanySubmit = async () => {
    const payload = {
      company: addedCompanyId,
      attachment_name: documentState.attachment_name,
    };

    try {
      setBtnLoadingFile(true);
      setapiloadingFile(true);
      let apiResponse;
      let customerHeaders = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();

      formData.append("attachment_file", uploadFile);
      formData.append("form_data", JSON.stringify(payload));
      if (companyDocumentId === null) {
        apiResponse = await postRequest(
          "company-attachment/",
          formData,
          customerHeaders
        );
      } else {
        apiResponse = await patchRequest(
          `company-attachment/${companyDocumentId}/`,
          formData,
          customerHeaders
        );
      }

      if (apiResponse.data.success === true) {
        handleRefreshGrid();
        SuccessNotificationMsg(
          companyDocumentId === null
            ? t("document_added_successfully")
            : t("document_updated_successfully")
        );
        setCompanyDocumentId(null);
        setDocumentState({ attachment_name: null });

        formRef.current.setFieldsValue({
          attachment_name: "",
        });
        setDocumentState((prevState) => ({
          ...prevState,
          attachment_file: null,
        }));
        setBtnDisplay("Add");
        setUploadFile("");
        setFileName(null);
        setFileLink(null);
        setSize(null);
        setBtnLoadingFile(false);
        setapiloadingFile(false);
        setBtnLoadingFile(false);
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoadingFile(false);
      setapiloadingFile(false);
      setBtnLoadingFile(false);
    }
  };

  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View and update your company&apos;s profile information,
                  including keyperson and documents.
                </span>
              }
            >
              <h3>{t("My Company")}</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>{t("My Company")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

    
          <Content className="stepscontentwrap" >
              {
          authUserData().company_role === "Company Admin" && authUserData().employee === null && <SubscriptionNotification />
        }
            <div className="stepsContent">
              <div className="formwrapper">
                <Spin spinning={apiloading}>
                  <Collapse defaultActiveKey={["1", "3"]}>
                    <Panel header="1. Company Details" key="1">
                      <Form
                        onFinish={handleSubmit}
                        autoComplete="off"
                        ref={formRef}
                      >
                        <Row gutter={[15]}>
                          <Col xs={24} sm={24} md={8} lg={6} xl={6}>
                            <CompanyOnboardingLogo
                              setUploadFileProfilePic={setUploadFileProfilePic}
                              fileList={fileList}
                              setFileList={setFileList}
                              identifyProfileUrl={identifyProfileUrl}
                              setIdentifyProfileUrl={setIdentifyProfileUrl}
                              beforeUpload={beforeUpload}
                            />
                          </Col>
                        </Row>
                        <h3
                          style={{
                            backgroundColor: "#F8F8F8",
                            padding: "10px 20px",
                            borderRadius: "10px",
                            margin: "10px 0",
                          }}
                        >
                          {t("Business Information")}
                        </h3>
                        <Row gutter={[10]}>
                          <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                            <div className="verifywrap">
                              <InputField
                                name="gst_no"
                                label={t("place_gst_no5")}
                                placeholder={t("place_gst_no")}
                                rules={t("val_gst_no")}
                                pattern={
                                  "^[0-9]{2}[A-Z]{5}[0-9]{4}" +
                                  "[A-Z]{1}[1-9A-Z]{1}" +
                                  "Z[0-9A-Z]{1}$"
                                }
                                prefix={<IdcardOutlined />}
                                disabled
                                handleInputChange={handleGstInputChange}
                              />
                              {/* {verifyGstButtonView === true ? ( */}
                              {/* {verifyGstButtonView === true ? (

                                <ButtonField
                                  type="primary"
                                  label={t("Verify")}
                                  className="SaveGradiantBtn verify"
                                  loading={btnLoadingVerifyGst}
                                  onClick={handleGstNumberVerify}
                                  disabled={true}
                                />
                              ) : (
                                ""
                              )} */}

                              {verificationStatus === "success" && (
                                <img
                                  src={verifybtn}
                                  alt="Verify Button"
                                  style={{ height: "36px", marginTop: "29px" }}
                                />
                              )}
                            </div>
                          </Col>

                          <Col xs={24} sm={24} md={10} xl={6} xxl={4}>
                            <div className="verifywrap">
                              <InputField
                                name="udyam_aadhaar_no"
                                label={t("Udyam Number")}
                                placeholder={t("Enter Udyam Number")}
                                prefix={<IdcardOutlined />}
                                handleInputChange={handleInputAdhaarChange}
                                disabled={true}
                              />
                              {/* {verifyAdhaarButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn verify"
                                  onClick={handleAdhaarNumberVerify}
                                  label={t("Verify")}
                                  disabled={true}
                                  loading={btnLoadingAdhaar}
                                />
                              ) : (
                                ""
                              )} */}

                              {verificationResultAdhaar === "success" && (
                                <img
                                  src={verifybtn}
                                  alt="Verify Button"
                                  style={{ height: "36px", marginTop: "29px" }}
                                />
                              )}
                            </div>
                          </Col>

                          <Col xs={24} sm={24} md={10} xl={6} xxl={4}>
                            <div className="verifywrap">
                              <InputField
                                name="company_pan"
                                label={t("label_client_pan")}
                                placeholder={t("pl_client_pan")}
                                pattern={"^[A-Z]{5}[0-9]{4}[A-Z]{1}$"}
                                nonRequiredRules={t("val_company_pan")}
                                prefix={<IdcardOutlined />}
                                handleInputPancardChange={
                                  handleInputPancardChange
                                }
                                disabled={true}
                              />
                              {/* {verifyPancardButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn verify"
                                  onClick={handlePancardNumberVerify}
                                  label={t("Verify")}
                                  disabled={true}
                                  loading={btnLoadingPan}
                                />
                              ) : (
                                ""
                              )} */}

                              {verificationResultPancard === "success" && (
                                <img
                                  src={verifybtn}
                                  alt="Verify Button"
                                  style={{ height: "36px", marginTop: "29px" }}
                                />
                              )}
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                            <InputField
                              name="name"
                              label={t("label_company_name")}
                              placeholder={t("pl_company_name")}
                              rules={t("val_company_name")}
                              prefix={<Vector />}
                              handleInputChange={handleInputChange}
                              max={40}
                            />
                          </Col>
                          <Col
                            xs={24}
                            sm={24}
                            md={12}
                            lg={6}
                            xl={6}
                            
                          >
                            <Form.Item
                              name="no_of_employees"
                              label={t("label_no_of_employee")}
                              prefix={<User />}
                              rules={[
                                {
                                  required: false,
                                  message: (
                                    <Trans>{t("val_no_of_employee")}</Trans>
                                  ),
                                },
                              ]}
                            >
                              <Select
                                showArrow
                                allowClear
                                showSearch
                                placeholder={t("pl_no_of_employee")}
                                optionFilterProp="children"
                                onChange={(value) =>
                                  handleSelectChange("no_of_employees", value)
                                }
                              >
                                <Select.Option value="1-10 employees">
                                  1-10 employees
                                </Select.Option>
                                <Select.Option value="11-50 employees">
                                  11-50 employees
                                </Select.Option>
                                <Select.Option value="51-200 employees">
                                  51-200 employees
                                </Select.Option>
                                <Select.Option value="201-500 employees">
                                  201-500 employees
                                </Select.Option>
                                <Select.Option value="501-1000 employees">
                                  501-1000 employees
                                </Select.Option>
                                <Select.Option value="1001-5000 employees">
                                  1001-5000 employees
                                </Select.Option>
                                <Select.Option value="5001-10000 employees">
                                  5001-10000 employees
                                </Select.Option>
                                <Select.Option value="10000 + employees">
                                  10000+ employees
                                </Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={24}
                            sm={24}
                            md={12}
                            lg={6}
                            xl={6}
                            
                          >
                            <InputField
                              name="cin_no"
                              label={t("label_cin_number")}
                              placeholder={t("pl_cin_number")}
                              handleInputChange={handleInputChange}
                              // rules={t("val_cin_number")}
                              pattern={"^(?! +$)[a-zA-Z0-9_ ]+$"}
                              max={21}
                            />
                          </Col>
                          <Col
                            xs={24}
                            sm={24}
                            md={12}
                            lg={8}
                            xl={8}
                            
                          >
                            <Form.Item
                              name="sector"
                              label=" Sector Name"
                              prefix={<User />}
                            >
                              <Select
                                showArrow
                                showSearch
                                allowClear
                                optionFilterProp="children"
                                placeholder="Enter sector name"
                                onChange={(value) =>
                                  handleSectorSelectChange(value)
                                }
                              >
                                {sectorName.map((item) => (
                                  <Option key={item.id} value={item.id}>
                                    {item.sector_name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={24}
                            sm={24}
                            md={12}
                            lg={6}
                            xl={6}
                            
                          >
                            <InputField
                              name="website"
                              label={t("pl_website")}
                              placeholder={t("place_website")}
                              pattern={
                                "^((https?|ftp|smtp)://)?(www\\.)?[a-z0-9]+(-[a-z0-9]+)*\\.(com|org|net|co|in|co\\.in|[a-z]{2,})$"
                              }
                              nonRequiredRules={t("val_website")}
                              prefix={<Website />}
                              handleInputChange={handleInputChange}
                            />
                          </Col>

                          <Col
                            xs={24}
                            sm={24}
                            md={12}
                            lg={6}
                            xl={6}
                            
                          >
                            <TextAreaField
                              name="about_company"
                              label={t("pl_about_company")}
                              placeholder={t("place_about_company")}
                              nonRequiredRules={t("val_about_company")}
                              prefix={<About />}
                              handleInputChange={handleInputChange}
                            />
                          </Col>
                        </Row>
                        <h3
                          style={{
                            backgroundColor: "#F8F8F8",
                            padding: "10px 20px",
                            borderRadius: "10px",
                            margin: "10px 0",
                          }}
                        >
                          {t("Contact Information")}
                        </h3>
                        <Row gutter={5}>
                          <Col
                            xs={24}
                            sm={24}
                            md={12}
                            lg={5}
                            xl={5}
                            
                          >
                            <InputField
                              name="first_name"
                              label={t("label_person_name")}
                              placeholder={t("pl_person_name")}
                              pattern={"^[a-zA-Z ]+$"}
                              rules={t("val_person_name")}
                              prefix={<Name />}
                              handleInputChange={handleInputChange}
                              max={30}
                            />
                          </Col>
                          <Col
                            xs={24}
                            sm={24}
                            md={12}
                            lg={5}
                            xl={5}
                            
                          >
                            <InputField
                              name="designation"
                              label={t("label_designation")}
                              pattern={"^[a-zA-Z ]+$"}
                              placeholder={t("place_designation")}
                              rules={t("val_designation")}
                              prefix={<AddressLine />}
                              handleInputChange={handleInputChange}
                              max={30}
                            />
                          </Col>
                          <Col xs={24} sm={24} md={10} lg={6} xl={6}>
                            <div className="verifywrap">
                              <EmailField
                                name="email"
                                label={t("label_email")}
                                placeholder={t("pl_email_2")}
                                rules={t("val_email")}
                                prefix={<Email />}
                                handleInputChange={handleInputChangeEmail}
                                disabled={true}
                              />
                              {/* {verifyEmailButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn verify"
                                  onClick={handleEmailVerify}
                                  label={t("Verify")}
                                  loading={btnLoadingEmail}
                                />
                              ) : (
                                ""
                              )} */}

                              {verificationResultEmail === "success" && (
                                <img
                                  src={verifybtn}
                                  alt="Verify Button"
                                  style={{ height: "36px", marginTop: "29px" }}
                                ></img>
                              )}
                            </div>
                          </Col>

                          <Col xs={24} sm={24} md={12} lg={7} xl={7}>
                            <div className="verifywrap">
                              <Form.Item
                                name="phone"
                                label={t("label_mobileNumber")}
                                placeholder={t("pl_mobileNumber")}
                                rules={[
                                  {
                                    required: true,
                                    validator: validatePhoneNumber,
                                    message: (
                                      <Trans> {t("val_mobileNumber")}</Trans>
                                    ),
                                  },
                                ]}
                              >
                                <PhoneInput
                                  className="PhoneSection"
                                  country={"in"}
                                  value={state?.phone}
                                  onChange={handlePhoneInputChange}
                                />
                              </Form.Item>
                              {verifyPhoneButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn verify"
                                  onClick={handleContactNumberVerify}
                                  label={t("Verify")}
                                  loading={btnLoadingPhone}
                                />
                              ) : (
                                ""
                              )}

                              {verificationResultContact === "success" && (
                                <img
                                  src={verifybtn}
                                  alt="Verify Button"
                                  style={{ height: "36px", marginTop: "29px" }}
                                ></img>
                              )}
                            </div>
                          </Col>

                          <Row gutter={32}>
                          <Col xs={24} xl={12} className="bdr">
                              <div className="colwrap">
                                <div className="colsubtitle">
                                  Registered Business Address
                                </div>
                                <Row gutter={16}>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="registered_business_address_building"
                                      label={t("Shop No., Building, Apartment")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_address")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("pl_street_address")}
                                        value={
                                          state.registered_business_address_building
                                        }
                                        onChange={(e) =>
                                          handleChange(
                                            "registered_business_address_building",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="registered_business_address_area"
                                      label={t("Area, Street, Sector, Village")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_address")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("pl_street_address")}
                                        value={
                                          state.registered_business_address_area
                                        }
                                        onChange={(e) =>
                                          handleChange(
                                            "registered_business_address_area",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="registered_business_address_landmark"
                                      label={t("pl_landmark")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_land_mark")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("place_land_mark")}
                                        value={
                                          state.registered_business_address_landmark
                                        }
                                        onChange={(e) =>
                                          handleChange(
                                            "registered_business_address_landmark",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="registered_business_address_pincode"
                                      label={t("pl_pincode")}
                                      prefix={<ZipCode />}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_postal_zip_code")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <AutoComplete
                                        className="autoComplete"
                                        onSearch={onSearchBilling}
                                        value={
                                          state.registered_business_address_pincode
                                        }
                                        optionFilterProp="children"
                                        allowClear
                                        placeholder={t("pl_pincodeselect")}
                                        onChange={handlePincodeBillingChange}
                                        onKeyPress={(e) => {
                                          if (!/^\d$/.test(e.key)) {
                                            e.preventDefault(); // blocks any non-numeric key
                                          }
                                        }}
                                      >
                                        {pincodeListBilling.map((option) => (
                                          <Option
                                            key={option.id}
                                            value={option.pincode_number}
                                          >
                                            {option.pincode_number}
                                          </Option>
                                        ))}
                                      </AutoComplete>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="registered_business_address_city"
                                      label={t("pl_city")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>{t("val_city")}</Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("place_city")}
                                        value={
                                          state.registered_business_address_city
                                        }
                                        disabled
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="registered_business_address_state"
                                      label={t("pl_state_province")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_state_province")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        value={
                                          state.registered_business_address_state
                                        }
                                        placeholder={t("place_state")}
                                        disabled
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                            <Col xs={24} xl={12}>
                              <div className="colwrap">
                                <div className="colsubtitle">
                                  Current Business Address
                                  <Tooltip
                                    title="Same as Billing Address"
                                    name="same_as_billing_address"
                                  >
                                    <Checkbox
                                      style={{ marginLeft: "10px" }}
                                      checked={sameAsCurrentAddress}
                                      onChange={(e) =>
                                        handleSameAsCurrentAddressChange(e)
                                      }
                                    ></Checkbox>
                                  </Tooltip>
                                </div>
                                <Row gutter={16}>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="trading_address_building"
                                      label={t("Shop No., Building, Apartment")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_address")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("pl_street_address")}
                                        value={state.trading_address_building}
                                        onChange={(e) =>
                                          handleChange(
                                            "trading_address_building",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="trading_address_area"
                                      label={t("Area, Street, Sector, Village")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_address")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("pl_street_address")}
                                        value={state.trading_address_area}
                                        onChange={(e) =>
                                          handleChange(
                                            "trading_address_area",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="trading_address_landmark"
                                      label={t("pl_landmark")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_land_mark")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("place_land_mark")}
                                        value={state.trading_address_landmark}
                                        onChange={(e) =>
                                          handleChange(
                                            "trading_address_landmark",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="trading_address_pincode"
                                      label={t("pl_pincode")}
                                      prefix={<ZipCode />}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_postal_zip_code")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <AutoComplete
                                        className="autoComplete"
                                        onSearch={onSearchShipping}
                                        value={state.trading_address_pincode}
                                        optionFilterProp="children"
                                        allowClear
                                        placeholder={t("pl_pincodeselect")}
                                        onChange={handlePincodeShippingChange}
                                        onKeyPress={(e) => {
                                          if (!/^\d$/.test(e.key)) {
                                            e.preventDefault(); // blocks any non-numeric key
                                          }
                                        }}
                                      >
                                        {pincodeListShipping.map((option) => (
                                          <Option
                                            key={option.id}
                                            value={option.pincode_number}
                                          >
                                            {option.pincode_number}
                                          </Option>
                                        ))}
                                      </AutoComplete>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="trading_address_city"
                                      label={t("pl_city")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>{t("val_city")}</Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("place_city")}
                                        value={state.trading_address_city}
                                        disabled
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="trading_address_state"
                                      label={t("pl_state_province")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_state_province")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("place_state")}
                                        value={state.trading_address_state}
                                        disabled
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </Row>
                        <>
                          {authUserData()?.permission.includes(
                            "company|view_keypersons"
                          ) && (
                            <>
                              <Collapse>
                                <Panel header="Key Persons" key="3">
                                  <KeyPersonCompany
                                    state={state}
                                    setState={setState}
                                    companyId={CompanyId}
                                  />
                                </Panel>
                              </Collapse>
                            </>
                          )}
                        </>
                        <div className="FormFooter">
                          <ButtonField
                            type="primary"
                            className="CancelGradiantBtn"
                            htmlType="button"
                            label={t("cancel")}
                            onClick={() => navigate("/dashboard")}
                          />
                          <ButtonField
                            type="primary"
                            className="SaveGradiantBtn"
                            htmlType="Submit"
                            label={t("save")}
                            loading={btnLoading}
                          />
                        </div>
                      </Form>
                    </Panel>
                  </Collapse>
                </Spin>
                <Collapse>
                  <Panel header="2. Company Documents" key="7">
                    {authUserData()?.permission.includes(
                      "company|view_attachment"
                    ) && (
                      <>
                        {formSubmitted && (
                          <>
                            <Spin spinning={apiloadingFile}>
                              <Form
                                onFinish={handleCompanySubmit}
                                autoComplete="off"
                                ref={formRef}
                              >
                               
                                <Row gutter={[15]}>
                                  <Col
                                    xs={16}
                                    sm={16}
                                    md={6}
                                    lg={6}
                                    xl={6}
                                    
                                  >
                                    <InputField
                                      name="attachment_name"
                                      className="BrowsButtonSec"
                                      label={t("pl_document_name")}
                                      placeholder={t("pl_enter_document_name")}
                                      handleInputChange={handleDocumentChange}
                                      prefix={<FileAlt />}
                                      rules={t("val_document_name")}
                                      pattern={"^[a-zA-Z ]+$"}
                                    />
                                  </Col>

                                  <Col
                                    xs={16}
                                    sm={16}
                                    md={8}
                                    lg={6}
                                    xl={4}
                                    
                                  >
                                    <Space style={{ alignItems: "flex-start" }}>
                                      <Form.Item
                                        className="BrowsButtonSec"
                                        label={t("pl_upload_document")}
                                        name="attachment_file"
                                        rules={[
                                          {
                                            required: false,
                                            message: (
                                              <Trans>{t("val_file")}</Trans>
                                            ),
                                          },
                                        ]}
                                      >
                                        <Upload
                                          className="BrowsButton"
                                          {...uploadProps}
                                          name="attachment_file"
                                        >
                                          <Button icon={<FileImageOutlined />}>
                                            {t("place_upload_document")}
                                          </Button>
                                          <div className="condition">
                                            {" "}
                                            <p
                                              style={{
                                                color:
                                                  size > 2097152
                                                    ? "red"
                                                    : "GrayText",
                                              }}
                                            >
                                              {t("upload_fileSize")}{" "}
                                              {t(
                                                "upload_imagefileType_company"
                                              )}
                                            </p>
                                          </div>
                                        </Upload>
                                        {size <= 2097152 && (
                                          <>
                                            <Space
                                              className="uploadedfile"
                                              size={[12, 16]}
                                            >
                                              <a
                                                href={fileLink}
                                                className="link-color"
                                                target="_blank"
                                                rel="noreferrer"
                                              >
                                                {fileLink
                                                  ? truncateFileName(filename)
                                                  : truncateFileName(fileName)}
                                              </a>
                                              {fileLink && (
                                                <DeleteOutlined
                                                  onClick={() =>
                                                    handleFileDelete(
                                                      "attachment_file"
                                                    )
                                                  }
                                                />
                                              )}
                                              {fileName && (
                                                <DeleteOutlined
                                                  onClick={() =>
                                                    handleDelete(
                                                      "attachment_file"
                                                    )
                                                  }
                                                />
                                              )}
                                            </Space>
                                          </>
                                        )}
                                      </Form.Item>
                                    </Space>
                                  </Col>
                                  <Col
                                    xs={8}
                                    sm={8}
                                    md={8}
                                    lg={6}
                                    xl={4}
                                    
                                  >
                                    <ButtonField
                                      type="primary"
                                      className="SaveGradiantBtn mt-4"
                                      htmlType="Submit"
                                      label={t(btnDisplay)}
                                      loading={btnLoadingFile}
                                    />
                                  </Col>
                                  <Col
                                  xs={8}
                                  sm={8}
                                  md={8}
                                  lg={10}
                                  xl={10}
                                  className="tbl-action"
                                  style={{display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "12px"}}
                                >
                                  <div className="searchwrp">
                                    <Space direction="vertical">
                                      <Search
                                        prefix={
                                          <img
                                            src={SearchIcon}
                                            alt="SearchIcon"
                                            className="SearchIcon"
                                            width={22}
                                          />
                                        }
                                        placeholder={t("pl_search_document")}
                                        onChange={searchCallbackDelayed}
                                        style={{
                                          width: 250,
                                        }}
                                      />
                                    </Space>
                                  </div>
                                  {selectedRow.length > 0 && (
                                    <Popconfirm
                                      className="action"
                                      title={t("pop_title")}
                                      okText={t("pop_ok")}
                                      cancelText={t("pop_cancel")}
                                      placement="left"
                                      onConfirm={() => handleArchive()}
                                    >
                                      <ButtonField
                                        className="BlueShadowBtn"
                                        type="primary"
                                        htmlType="button"
                                        label={t("pl_archive")}
                                      />
                                    </Popconfirm>
                                  )}
                                  <Tooltip
                                    placement="topLeft"
                                    title="Archived Records"
                                  >
                                    <Link
                                      to={`/company-onboarding-document/archive`}
                                    >
                                      <Archiveicon />
                                    </Link>
                                  </Tooltip>
                                </Col>
                                </Row>
                              </Form>
                            </Spin>
                            <>
                              {/* <Row className="tblheader">
                                <Col
                                  xs={24}
                                  sm={24}
                                  md={12}
                                  lg={12}
                                  xl={12}
                                  className="tbl-heading"
                                ></Col>
                                <Col
                                  xs={24}
                                  sm={24}
                                  md={24}
                                  lg={12}
                                  xl={12}
                                  className="tbl-action"
                                  style={{display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "12px"}}
                                >
                                  <div className="searchwrp">
                                    <Space direction="vertical">
                                      <Search
                                        prefix={
                                          <img
                                            src={SearchIcon}
                                            alt="SearchIcon"
                                            className="SearchIcon"
                                            width={22}
                                          />
                                        }
                                        placeholder={t("pl_search_document")}
                                        onChange={searchCallbackDelayed}
                                        style={{
                                          width: 250,
                                        }}
                                      />
                                    </Space>
                                  </div>
                                  {selectedRow.length > 0 && (
                                    <Popconfirm
                                      className="action"
                                      title={t("pop_title")}
                                      okText={t("pop_ok")}
                                      cancelText={t("pop_cancel")}
                                      placement="left"
                                      onConfirm={() => handleArchive()}
                                    >
                                      <ButtonField
                                        className="BlueShadowBtn"
                                        type="primary"
                                        htmlType="button"
                                        label={t("pl_archive")}
                                      />
                                    </Popconfirm>
                                  )}
                                  <Tooltip
                                    placement="topLeft"
                                    title="Archived Records"
                                  >
                                    <Link
                                      to={`/company-onboarding-document/archive`}
                                    >
                                      <Archiveicon />
                                    </Link>
                                  </Tooltip>
                                </Col>
                              </Row> */}

                              <Table
                                rowSelection={rowSelection}
                                columns={columns}
                                rowKey={(record) => record.id}
                                dataSource={companyDocumentList}
                                loading={loading}
                                pagination={{
                                  defaultCurrent: state.page,
                                  defaultPageSize: state.pagesize,
                                  total: totalCount,
                                  showTotal: (total) => `Total ${total} items`,
                                  showSizeChanger: true,
                                  locale: {
                                    items_per_page: "Items / Page", 
                                  },
                                }}
                                onChange={handleTableChange}
                              />
                            </>
                          </>
                        )}
                      </>
                    )}
                  </Panel>
                </Collapse>
              </div>
            </div>
          </Content>
     
      <Modal
        className="ModelPopupSec"
        title={"Verify Email"}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={handleCancel}
        wrapClassName="modal-wrapper"
        keyboard={false}
      >
        <VerifyOtpModal
          handleCancel={handleCancel}
          setVerifyEmailButtonView={setVerifyEmailButtonView}
          OTP={OTP}
          setOTP={setOTP}
          state={state}
          setState={setState}
          setMinutes={setMinutes}
          setSeconds={setSeconds}
          seconds={seconds}
          minutes={minutes}
          handleSendOtpEmail={handleSendOtpEmail}
          setVerificationResultEmail={setVerificationResultEmail}
        />
      </Modal>
      <Modal
        className="ModelPopupSec"
        title={"Verify Mobile"}
        open={isModalOpenPhone}
        onOk={handleOkPhone}
        onCancel={handleCancelPhone}
        closable={handleCancelPhone}
        wrapClassName="modal-wrapper"
        keyboard={false}
      >
        <PhoneOtpVerify
          handleCancelPhone={handleCancelPhone}
          setVerifyPhoneButtonView={setVerifyPhoneButtonView}
          OTP={OTPPhone}
          setOTP={setOTPPhone}
          state={state}
          setState={setState}
          setMinutes={setMinutesPhone}
          setSeconds={setSecondsPhone}
          seconds={secondsPhone}
          minutes={minutesPhone}
          handleSendOtpPhone={handleSendOtpPhone}
          setVerificationResultContact={setVerificationResultContact}
        />
      </Modal>
    </>
  );
};

export default MyCompany;
